import {
  ChatsFilterRequest,
  ChatStatus,
  SortByColumn,
  SortDirection,
} from '../queries'

export interface SearchParams {
  chatId: string
  patientFirstName: string
  patientLastName: string
  clinicianUuid: string
  status: ChatStatus | ''
}

export const DEFAULT_SEARCH_PARAMS: SearchParams = {
  chatId: '',
  patientFirstName: '',
  patientLastName: '',
  clinicianUuid: '',
  status: '',
}

export const buildChatsFilter = (
  params: SearchParams,
  currentPage: number,
  limit: number,
  sort?: SortDirection,
  sortBy?: SortByColumn
): ChatsFilterRequest => {
  const f: ChatsFilterRequest = {
    limit,
    offset: (currentPage - 1) * limit,
  }

  if (sort) {
    f.sort = sort
  }
  if (sortBy) {
    f.sort_by = sortBy
  }

  if (params.chatId) {
    f.chat_id = params.chatId
  }
  if (params.patientFirstName) {
    f.patient_first_name = params.patientFirstName
  }
  if (params.patientLastName) {
    f.patient_last_name = params.patientLastName
  }
  if (params.clinicianUuid) {
    f.clinician_uuid = params.clinicianUuid
  }
  if (params.status) {
    f.status = params.status
  }

  return f
}
